// ----- Scale Recaptcha function ----- 
function scaleCaptcha(elementWidth) {
    var reCaptchaWidth = 304;
	var containerWidth = $('.g-recaptcha').parent().width();
  
    if(reCaptchaWidth > containerWidth) {

        var captchaScale = containerWidth / reCaptchaWidth;

        $('.g-recaptcha').css({ 'transform':'scale('+captchaScale+')' });

    } else {
    
        $('.g-recaptcha').css({ 'transform':'scale(1)' });  	
    }
}

$(document).ready(function(){
	
	// Custom File Upload JS
	var file_uploads = $('.wpcf7-form-control.wpcf7-file');

	file_uploads.each(function(index,value){

		var upload = $(this);
		upload.before('<span class="a-custom-file-input"><i class="fa fa-upload" aria-hidden="true"></i> Select your file</span>');

	});

	$('.wpcf7-form-control.wpcf7-file').change(function() { 
		var file_name = $(this).prop("files")[0].name;
	    $(this).siblings('.a-custom-file-input').text(file_name);
	});


	//
	if ( $('.wpcf7-form').length ) {
		var wpcf7Elm = document.querySelector( '.wpcf7' );
	 
		wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
			setTimeout(function(){ 
				$('.wpcf7-file').each(function() {
					if ( $(this).hasClass('wpcf7-not-valid') ) {
				    	$(this).siblings('.a-custom-file-input').addClass('a-custom-file-input--not-valid');
				    } else {
				    	$(this).siblings('.a-custom-file-input').removeClass('a-custom-file-input--not-valid');
				    } 
				});
			}, 0);
				
		}, false );
	}

	// Scale Recaptcha
	scaleCaptcha();
});

$( window ).resize(function() { scaleCaptcha(); });